import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { Donor } from '@interfaces';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<Donor, unknown>[] = [
		buildColumn(util, 'Id', row => row.donorId),
		buildColumn(util, 'Text', row => row.name),
		// buildColumn(util, 'Text', row => row.email, { header: 'EmailId' }),
		// buildColumn(util, 'Text', row => row.department, { header: 'Department' }),
		// buildColumn(util, 'Status', row => row.status),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.updatedUTC), { header: 'Updated', hidden: true }),
	];


	return columns;

}